import React from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { DialogBody } from '@dev/ee-components';
import { EditorSendTestData } from '@dev/template-editor';
import { ShowToast } from '@/store/toast/actions';
import { ResendActivationEmail } from '@/store/auth/actions';
import { ShowDialogParams } from '@/store/dialog/types';
import { getAccount } from '@/store/account/types';
import { SendTestData } from '@/store/templateEditor/types';
import { SendTest, SetSendTestData } from '@/store/templateEditor/actions';
import { isAccountActivated } from '@/services/Secuirty';
import { SendTestModal } from '../components/SendTestModal';

export const useGetSendTestModalParams = (): {
    getSendTestModalParams: (data: EditorSendTestData) => ShowDialogParams;
} => {
    const dispatch = useDispatch();
    const { t } = useTranslation();
    const account = useSelector(getAccount);

    const onSendTest = (): void => {
        dispatch(SendTest());
    };

    const resendActivationEmail = async (): Promise<void> => {
        const email = account?.GeneralInfo?.UserName;
        try {
            await dispatch(ResendActivationEmail?.({ Email: email }));
            dispatch(
                ShowToast({
                    severity: 'info',
                    message: t('activationemailresent2'),
                    duration: 1000,
                })
            );
        } catch {
            dispatch(
                ShowToast({
                    severity: 'error',
                    message: t('errorinfo'),
                    duration: 3000,
                })
            );
        }
    };

    const getSendTestModalParams = (data: EditorSendTestData): ShowDialogParams => {
        if (!isAccountActivated()) {
            return {
                title: t('accounthasntbeenactivated'),
                cancelLabel: t('cancel'),
                confirmLabel: t('resendactivationemail'),
                body: <DialogBody variant="info">{t('campaign_activateaccount_dialog')}</DialogBody>,
                onClickConfirm: resendActivationEmail,
            };
        }

        const defualtValues: SendTestData = {
            editorData: data,
            toEmails: account?.Profile?.Email || '',
            fromEmail: data.defaultSenderEmail || account?.Profile?.Email || '',
            fromName: data.defaultSenderName || account?.Profile?.FirstName || '',
            subject: data.defaultSubject || '',
            previewText: data.defaultPreviewText || '',
            errors: null,
        };
        dispatch(SetSendTestData(defualtValues));
        return {
            title: t('sendtest'),
            confirmLabel: t('send'),
            cancelLabel: t('cancel'),
            onClickConfirm: onSendTest,
            body: <SendTestModal />,
            id: 'sendtest',
            isHiddenManually: true,
        };
    };
    return { getSendTestModalParams };
};
